module.exports = __webpack_public_path__ + "img/xindadasha.99d5ef87.jpg";